import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { translations } from '../i18n'
import { unsubscribeBlog } from '../actions/blogActions'
import Loader from '../components/Loader'
import Message from '../components/Message'

function UnsubscribeScreen() {
  const dispatch = useDispatch()
  const { token } = useParams()
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang]
  const { loading, success, error } = useSelector(s => s.rootReducer.unsubscribeRed)

  useEffect(() => { dispatch(unsubscribeBlog(token)) }, [dispatch, token])

  return (
    <div>
      <div style={{ background: 'var(--navy)', color: '#fff', padding: '48px 0 36px' }}>
        <Container>
          <h1 style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, marginBottom: '.4rem' }}>{T.sections.blog}</h1>
        </Container>
      </div>
      <div className='fc-section'>
        <Container>
          {loading && <Loader />}
          {!loading && success && <Message variant='success'>{T.blog.unsub_success}</Message>}
          {!loading && error && <Message variant='danger'>{T.blog.unsub_error}</Message>}
          <div style={{ marginTop: '1.5rem' }}>
            <Link to='/blog/' style={{ color: 'var(--teal)', fontWeight: 500 }}>{T.blog.unsub_back}</Link>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default UnsubscribeScreen
